import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { closeWorkAssignments, IWorkAssignment } from 'wisestep-api';
import { ScrollableTabs } from 'wisestep-base';

import CardWrapper from '../../../features/automatedEmailCampaignSettings/childRoutes/CardWrapper';
import { failed, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { createAssignmentsObject, JobAllocationTabList } from '../components/helper/JobsCrmHelper';
import { useJobCRMContext } from '../context';
import useJobUnassignPermission from '../hooks/useJobUnassignPermission';

import ActiveRecruiterAllocation from './ActiveRecruiterAllocation';
import JobAllocationHeader from './JobAllocationHeader';
import RecruiterAllocation from './RecruiterAllocation';
import TeamAllocation from './TeamAllocation';

const JobAllocation = () => {
  const [index, setIndex] = useState<number>(0);
  const { job, getJobDetails } = useJobCRMContext();
  const { unAssignAllowed } = useJobUnassignPermission(job);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const unAssignRecruiter = async (recruiter: IWorkAssignment) => {
    const assignments = createAssignmentsObject();
    try {
      if (job?.id && recruiter.recruiterId && job?.assignedTo) {
        assignments.jobDTOList.push(job?.id);
        assignments.recruiterDTOList.push(recruiter.recruiterId);
        await closeWorkAssignments(assignments);
        setNotification(success('Recruiter Is Unassigned To The Job'));
        getJobDetails();
      }
    } catch (e) {
      setNotification(failed('Something went wrong, Please try again !!'));
    }
  };
  return (
    <Box mt={1}>
      <CardWrapper>
        <Grid display="flex" direction="column" rowGap={1}>
          <JobAllocationHeader accessChangeAdminTeam={unAssignAllowed} />
          <Grid item>
            <ScrollableTabs
              scrollList={JobAllocationTabList}
              getTabIndex={setIndex}
              defaultValue={index ?? 0}
            />
          </Grid>
          {index === 0 && (
            <RecruiterAllocation
              unAssignAllowed={unAssignAllowed}
              unAssignRecruiter={unAssignRecruiter}
            />
          )}
          {index === 1 && <TeamAllocation />}
          {index === 2 && (
            <ActiveRecruiterAllocation
              unAssignAllowed={unAssignAllowed}
              unAssignRecruiter={unAssignRecruiter}
            />
          )}
        </Grid>
      </CardWrapper>
    </Box>
  );
};

export default JobAllocation;
